if (!window.customElements.get('gift-card-drawer')) {
  class GiftCardDrawer extends HTMLElement {
    connectedCallback() {
      this.closeButton = this.querySelector('[data-gift-card-drawer-close]');
      this.overlay = this.querySelector('[data-gift-card-drawer-overlay]');
      this.price = this.querySelector('[data-gift-card-drawer-price]');
      this.buyAgree = this.querySelector('[data-gift-card-drawer-buy-agree]');
      this.buySubmit = this.querySelector('[data-gift-card-drawer-buy-submit]');
      this.buyForm = this.querySelector('[data-gift-card-drawer-buy-form]');
      this.recipientAgree = this.querySelector('[data-gift-card-drawer-recipient-agree]');
      this.recipientSubmit = this.querySelector('[data-gift-card-drawer-recipient-submit]');
      this.recipientForm = this.querySelector('[data-gift-card-drawer-recipient-form]');
      this.toggleButton = document.querySelector('[data-gift-card-drawer-toggle]');
      this.timezoneOffsetInput = this.querySelector('[data-gift-card-recipient-timezone-offset]');

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', (event) => this.open());
      }

      if (this.buyAgree && this.buySubmit) {
        this.buyAgree.addEventListener('change', () => {
          this.buySubmit.toggleAttribute('disabled', !this.buyAgree.checked);

          if (this.buyAgree.checked) {
            this.buyForm.classList.remove('pointer-events-none', 'opacity-50');
            this.recipientForm.classList.add('pointer-events-none', 'opacity-50');
          } else {
            this.buyForm.classList.remove('pointer-events-none', 'opacity-50');
            this.recipientForm.classList.remove('pointer-events-none', 'opacity-50');
          }
        });
      }

      if (this.recipientAgree && this.recipientSubmit) {
        this.recipientAgree.addEventListener('change', () => {
          this.recipientSubmit.toggleAttribute('disabled', !this.recipientAgree.checked);

          if (this.recipientAgree.checked) {
            this.buyForm.classList.add('pointer-events-none', 'opacity-50');
            this.recipientForm.classList.remove('pointer-events-none', 'opacity-50');
          } else {
            this.buyForm.classList.remove('pointer-events-none', 'opacity-50');
            this.recipientForm.classList.remove('pointer-events-none', 'opacity-50');
          }
        });
      }

      document.addEventListener('variantOptionsChanged', (event) => {
        const variant = event?.detail?.variant;
        if (!variant) return;
        this.updateVariant(variant);
      });

      this.setTimezoneOffset();
    }

    setTimezoneOffset() {
      if (!this.timezoneOffsetInput) return;
      this.timezoneOffsetInput.value = new Date().getTimezoneOffset().toString();
    }

    updateVariant(variant) {
      if (this.price) {
        this.price.innerText = window.formatMoney(variant.price);
      }
    }

    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      window.trapFocus(this);
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      window.removeTrapFocus();
    }
  }

  window.customElements.define('gift-card-drawer', GiftCardDrawer);
}
